import type { VoidFunctionComponent } from 'react';
import { IconButton, icons } from '../../../../../../generic';
import { useDeleteTeamGroupTeam } from '../../../../../../../hooks/api';
import { useAddToast } from '../../../../../../../contexts/ToastContext';
import { useOnConfirm } from '../../../../../../../contexts/DialogContext';

type Props = {
  teamGroupId: number;
  teamId: number;
};

/**
 * Displays a remove button for a team group team.
 */
const TeamGroupTeamsTableRemove: VoidFunctionComponent<Props> = ({ teamGroupId, teamId }) => {
  const addToast = useAddToast();
  const onConfirm = useOnConfirm();
  const {
    mutateAsync: removeTeamFromTeamGroup,
    isLoading: isRemovingUser,
  } = useDeleteTeamGroupTeam(teamGroupId, teamId);

  const handleRemoveUser = () => {
    onConfirm({
      title: 'Are you sure?',
      body: 'Are you sure you want to remove this team from this team group?',
      confirmText: 'Remove',
      onConfirm: async () => {
        try {
          await removeTeamFromTeamGroup();
          addToast({
            type: 'success',
            content: 'Team removed from team group',
          });
        } catch (error) {
          addToast({
            type: 'error',
            content: 'Error removing team from team group',
          });
        }
      },
    });
  };

  return (
    <IconButton
      id={`remove-team-${teamId}`}
      icon={icons.xMark}
      isDisabled={isRemovingUser}
      onClick={handleRemoveUser}
    />
  );
};

export default TeamGroupTeamsTableRemove;
